<div class="sidenav hidden-print">
  <button type="button" class="sidemenu-trigger js-sidemenu-trigger" (click)="toggleMenu()">
    <span class="sandwich">
      <span class="sw-topper"></span>
      <span class="sw-bottom"><span class="sw-bottom__inner"></span></span>
      <span class="sw-footer"></span>
    </span>
    <span class="sidemenu-trigger__text">
      {{'Hide menu'|translate }}
    </span>
  </button>
  <ul class="sidemenu">
    <li class="sidemenu__item js-sidemenu-item active" [class.active]="isSelected('service_list')" (click)="select('service_list')">
      <span class="sidemenu__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path class="cls-1" d="M3.49,18.12A1.69,1.69,0,0,0,5.88,20.5L10.41,16,8,13.59Z" />
          <polygon class="cls-1" points="17.33 7.86 19.74 6.62 21 4.18 19.82 3 17.38 4.26 16.14 6.67 14.2 8.61 15.39 9.8 17.33 7.86" />
          <path class="cls-1" d="M17.85,14.26l-.23,0a3.34,3.34,0,0,0-1.17.22L9.54,7.54a3.34,3.34,0,0,0,.22-1.17l0-.23A3.34,3.34,0,0,0,4.95,3.34L7.19,5.58a1.1,1.1,0,0,1,.25.4A1.12,1.12,0,0,1,5.6,7.17L3.36,4.93A3.34,3.34,0,0,0,6.16,9.72l.23,0a3.37,3.37,0,0,0,1.17-.22l6.92,6.92a3.39,3.39,0,0,0-.22,1.17l0,.23A3.36,3.36,0,0,0,17.63,21a3.3,3.3,0,0,0,1.45-.34L16.83,18.4a1.15,1.15,0,0,1-.26-.4,1.12,1.12,0,0,1,1-1.51,1.11,1.11,0,0,1,.39.08,1.08,1.08,0,0,1,.4.25l2.24,2.24A3.32,3.32,0,0,0,21,17.61,3.36,3.36,0,0,0,17.85,14.26Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Service tasks'|translate }}
      </span>
    </li>
    <li class="sidemenu__item js-sidemenu-item active" [class.active]="isSelected('completed_works_list')" (click)="select('completed_works_list')">
      <span class="sidemenu__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
          <path class="cls-1" d="M9.22,12.38,5.92,16.5,3.71,14.29a1,1,0,0,0-1.42,1.42l3,3A1,1,0,0,0,6,19h.06a1,1,0,0,0,.72-.38l4-5a1,1,0,1,0-1.56-1.24Z" />
          <path class="cls-1" d="M9.22,2.38,5.92,6.5,3.71,4.29A1,1,0,0,0,2.29,5.71l3,3A1,1,0,0,0,6,9h.06a1,1,0,0,0,.72-.38l4-5A1,1,0,1,0,9.22,2.38Z" />
          <path class="cls-1" d="M14,7H29a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2Z" />
          <path class="cls-1" d="M29,15H14a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z" />
          <path class="cls-1" d="M29,25H14a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z" />
          <path class="cls-1" d="M9.71,21.29a1,1,0,0,0-1.42,0L6,23.59l-2.29-2.3a1,1,0,0,0-1.42,1.42L4.59,25l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L6,26.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,25l2.3-2.29A1,1,0,0,0,9.71,21.29Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Completed works'|translate }}
      </span>
    </li>
    <li class="sidemenu__item js-sidemenu-item" [class.active]="isSelected('service_report')" (click)="select('service_report')">
      <span class="sidemenu__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
          <path class="cls-1" d="M6,16h4V0H6ZM0,16H4V8H0ZM12,5V16h4V5Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Reports'|translate }}
      </span>
    </li>
  </ul>
</div>
